<div  class="botonApariencia">
    <div class="px-6 pt-5 w-full">
        <div class="flex flex-row h-[10px]">
            <div class=" w-[90%]"><h2 class="heading-2"></h2></div>
            <div class="ml-auto flex items-center">
                <img src="assets/svg/close-modal.svg" class="h-[12px] w-[12px] cursor-pointer" (click)="onClose()" />
              </div>
        </div>
    </div>
    
    <div class="bg-white flex flex-col text-[#37474F]">
        <div class="flex flex-col items-center gap-2.5 p-2.5 text-center leading-5 text-[24px] text-[#344563]">
            <img src="assets\svg\info-naranja.svg">
         </div>
         <div>
            <div class="flex flex-col items-center gap-2.5 p-2.5 text-center leading-5 text-[24px] text-[#344563]">
                {{titulo}}
            </div>
        </div>
        <div class="pb-4">
            <div>
                <div class="flex flex-col items-center gap-2.5 p-2.5 text-center leading-5 text-[16px] text-[#344563]">
                    {{message}}
                </div>
            </div>
        </div>
        <div class="flex flex-row gap-2 justify-center pb-3 px-4 ">

            <div class="flex justify-center w-3/4 gap-6">
                                <div class="w-fit">
                                        <app-btn class="flex" color="white" (click)="onClose()">{{botonCancelar}}
                                        </app-btn>
                                    </div>
                            <div class="w-fit">
                                <app-btn class="flex" type="submit" color="mezclado" (click)="okBtn()">{{botonOk}}
                                </app-btn>
                            </div>
            </div>
          </div>
    </div>
</div>